import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Presentational bridge between the dashboard header and the routed pages:
 * pages publish the count-chip text; the header hosts the date-range control
 * and publishes the selected range for list pages to consume. Pages may also
 * project their own title/actions into the header (e.g. the order detail page
 * shows PO#/Order# and its Guideline/Activity controls in the top bar).
 */
@Injectable({ providedIn: 'root' })
export class HeaderStateService {
  readonly badge = new BehaviorSubject<string | null>(null);
  readonly dateRange = new BehaviorSubject<{ gte: string; lte: string }>({
    gte: '',
    lte: '',
  });
  // When set, the header renders these in place of the breadcrumb title and
  // in the actions slot. The templates are declared by the routed page, so
  // their bindings and event handlers run in that page's context.
  readonly titleTemplate = new BehaviorSubject<TemplateRef<unknown> | null>(
    null
  );
  readonly actionsTemplate = new BehaviorSubject<TemplateRef<unknown> | null>(
    null
  );

  setBadge(text: string | null): void {
    this.badge.next(text);
  }

  setDateRange(range: { gte: string; lte: string }): void {
    this.dateRange.next(range);
  }

  setTitleTemplate(template: TemplateRef<unknown> | null): void {
    this.titleTemplate.next(template);
  }

  setActionsTemplate(template: TemplateRef<unknown> | null): void {
    this.actionsTemplate.next(template);
  }
}
